import React, { useMemo } from 'react'

import Button from 'components/Form/Button'
import BasicTable from 'components/Form/Table'
import CardsList from 'components/Form/TableCard'
import CustomTablePagination from 'components/CustomTablePagination'

import {
  Pagination,
  StatusBadge,
} from 'components/UserApprovalsTable/styled'
import { Actions, DesktopTable, MobileCards, TrainingName } from './styled'

function formatDate(value) {
  if (!value) return '—'
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? '—' : date.toLocaleString()
}

function formatStatus(value) {
  if (['pending', 'pending_trainer_approval', 'processing'].includes(value)) return 'Pending approval'
  if (value === 'approved') return 'Approved'
  if (value === 'rejected') return 'Rejected'
  return '—'
}

export default function TrainingApprovalsTable({
  rows = [],
  pagination,
  onReview,
  onPageChange,
}) {
  const columns = useMemo(() => [
    {
      title: 'Completion date',
      ref: 'requestedAt',
      renderCell: ({ row }) => formatDate(row?.requestedAt),
    },
    {
      title: 'Participant',
      ref: 'user',
      renderCell: ({ row }) => <TrainingName>{row?.user?.name || '—'}</TrainingName>,
    },
    {
      title: 'Training',
      ref: 'course',
      renderCell: ({ row }) => (
        <div>
          <TrainingName>{row?.course?.title || '—'}</TrainingName>
          <div>{row?.courseModule?.title || row?.quiz?.title || ''}</div>
        </div>
      ),
    },
    {
      title: 'Quiz score',
      ref: 'quizScore',
      renderCell: ({ row }) => row?.quizScore === null || row?.quizScore === undefined
        ? '—'
        : `${Math.round(Number(row.quizScore))}%`,
    },
    {
      title: 'Status',
      ref: 'status',
      renderCell: ({ row }) => <StatusBadge>{formatStatus(row?.status)}</StatusBadge>,
    },
    {
      title: 'Actions',
      ref: 'actions',
      renderCell: ({ row }) => (
        <Actions>
          <Button
            color="blue"
            nospace
            small
            width="92px"
            onClick={() => onReview(row.documentId)}
          >
            Review
          </Button>
        </Actions>
      ),
    },
  ], [onReview])

  return (
    <>
      <DesktopTable>
        <BasicTable columns={columns} rows={rows} />
      </DesktopTable>
      <MobileCards>
        <CardsList columns={columns} rows={rows} full noShadow />
      </MobileCards>
      {!pagination?.total || pagination.total <= pagination.pageSize ? null : (
        <Pagination>
          <CustomTablePagination
            count={pagination.total}
            page={Math.max(Number(pagination.page || 1) - 1, 0)}
            rowsPerPage={pagination.pageSize}
            onPageChange={onPageChange}
          />
        </Pagination>
      )}
    </>
  )
}
